import createIcon from '../../createIcon';

/**
 * @component @name CardTravel
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNi41SDE3VjQuNUMxNyAzLjM5IDE2LjExIDIuNSAxNSAyLjVIOUM3Ljg5IDIuNSA3IDMuMzkgNyA0LjVWNi41SDRDMi44OSA2LjUgMiA3LjM5IDIgOC41VjE5LjVDMiAyMC42MSAyLjg5IDIxLjUgNCAyMS41SDIwQzIxLjExIDIxLjUgMjIgMjAuNjEgMjIgMTkuNVY4LjVDMjIgNy4zOSAyMS4xMSA2LjUgMjAgNi41Wk05IDQuNUgxNVY2LjVIOVY0LjVaTTIwIDE5LjVINFYxNy41SDIwVjE5LjVaTTIwIDE0LjVINFY4LjVIN1YxMC41SDlWOC41SDE1VjEwLjVIMTdWOC41SDIwVjE0LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CardTravel = createIcon('CardTravel', [
  [
    'path',
    {
      d: 'M20 6.5H17V4.5C17 3.39 16.11 2.5 15 2.5H9C7.89 2.5 7 3.39 7 4.5V6.5H4C2.89 6.5 2 7.39 2 8.5V19.5C2 20.61 2.89 21.5 4 21.5H20C21.11 21.5 22 20.61 22 19.5V8.5C22 7.39 21.11 6.5 20 6.5ZM9 4.5H15V6.5H9V4.5ZM20 19.5H4V17.5H20V19.5ZM20 14.5H4V8.5H7V10.5H9V8.5H15V10.5H17V8.5H20V14.5Z',
      key: 'ibfhj3',
    },
  ],
]);

export default CardTravel;
